import React from 'react';

function ManagesSoftwarePage() {
    return <div>ManagesSoftwarePage</div>;
}

export default ManagesSoftwarePage;
